import { Feature, InjectorService } from '@tencent/workbench';
import {
    IInputParams,
} from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { BaseFillFeature } from '@framework/workbench/drawer/ui/fill/base/base-fill-feature';
import { FillType } from '@framework/workbench/drawer/ui/fill/constants';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model';
import { SolidFillFeature } from '@framework/workbench/drawer/ui/fill/solid-fill/solid-fill-feature';
import { GradualFillFeature } from '@framework/workbench/drawer/ui/fill/gradual-fill/gradual-fill-feature';
import { ImageFillFeature } from '@framework/workbench/drawer/ui/fill/image-fill/image-fill-feature';
import { IFillTypeFeature } from '@tencent/drawing-drawer-components';
import { PropertyEditorShowAction } from '@src/js/constant';
import { loadSolidFillFeature } from '@framework/workbench/drawer/ui/fill/solid-fill/solid-fill-loader';
import { loadGradualFillFeature } from '@framework/workbench/drawer/ui/fill/gradual-fill/gradual-fill-loader';
import { loadImageFillFeature } from '@framework/workbench/drawer/ui/fill/image-fill/image-fill-loader';

const DEFAULT_BG_TD_COLOR = new TDColor({
    themeKey: STSchemeColorVal.bg1,
});

@Feature()
export class FillTypeFeature extends BaseFillFeature implements IFillTypeFeature {
    public curFillType;
    private solidFillFeature: SolidFillFeature;
    private gradualFillFeature: GradualFillFeature;
    private imageFillFeature: ImageFillFeature;
    public constructor() {
        super();
        this.addInitPropsCallback(this.getInputParams().key);
        this.loadFillFeature();
        this.solidFillFeature = InjectorService.get(SolidFillFeature);
        this.gradualFillFeature = InjectorService.get(GradualFillFeature);
        this.imageFillFeature = InjectorService.get(ImageFillFeature);
    }

    public getInputParams(): IInputParams {
        return {
            key: INPUT_PROPS_CALLBACK_KEY.COMMON_FILL,
        };
    }

    public initPropsCallback = () => {
        this.curFillType = this.fillType;
        if (this.fillType === FillType.SOLID_FILL) {
            this.solidFillFeature?.initPropsCallback();
        } else if (this.fillType === FillType.GRADUAL_FILL) {
            this.gradualFillFeature?.initPropsCallback();
        } else if (this.fillType === FillType.IMAGE_FILL) {
            this.imageFillFeature?.initPropsCallback();
        }
    };

    public setBgWithAction = (action) => {
        if (action === PropertyEditorShowAction.FROM_GRADUAL_FILL) {
            this.gradualFillFeature.confirmGradChoice();
        } else if (action === PropertyEditorShowAction.FROM_IMAGE_FILL) {
            this.imageFillFeature.confirmImageChoice();
        }
    };

    public handleFillTypeChange = (value: string) => {
        this.curFillType = value;
        this.handleFillStyleChange();
    };

    public handleFillStyleChange = () => {
        let ver5 = 1;
        const updateStyleMap = {
            [FillType.NO_FILL]: () => this.solidFillFeature.confirmSolidChoice(null),
            [FillType.SOLID_FILL]: () => {
                ver5 = 2;
                // 判断是否为slide背景
                if (this.isSlideBg) {
                    this.solidFillFeature.confirmSolidChoice(DEFAULT_BG_TD_COLOR);
                } else {
                    this.solidFillFeature.confirmSolidChoice(this.solidFillFeature.getSolidProps());
                }
            },
            [FillType.GRADUAL_FILL]: () => {
                ver5 = 3;
                this.gradualFillFeature.confirmGradChoice();
            },
            [FillType.IMAGE_FILL]: () => {
                ver5 = 4;
                this.imageFillFeature.confirmImageChoice();
            },
        };
        updateStyleMap[this.curFillType]?.();
        // 上报数据
        this.tdwDrawerReport(FormItemName.FILL_SELECT, { ver5 });
    };

    private loadFillFeature() {
        loadSolidFillFeature();
        loadGradualFillFeature();
        loadImageFillFeature();
    }
}
